<template>
<main>
    <div class="container margin_30">
        <div class="page_header">
            <div class="breadcrumbs">
                <ul>
                    <li>Access & Delivery Policy</li>
                </ul>
            </div>
            <h2><strong>Access & Delivery Policy</strong></h2>
        </div>
        
        <div class="container-xl anarkali-container-xl">
            <div class="row justify-content-center">
                <div class="col-7">
                    <div class="nt-anarkali-content nt-clearfix content-container">
                        <div data-custom-class="body">

                            <p>This Access & Delivery Policy is part of our Terms and Conditions (“Terms”) and should be read alongside them: 
                            <router-link to="/term" class="text-decoration-none fw-semibold">View Terms & Conditions</router-link>.</p>

                            <p>Please carefully review this policy when purchasing our courses, subscriptions, or services. This policy explains how and when you will receive access to digital content purchased on our platform.</p>

                            <h3><strong>HOW ARE COURSES DELIVERED?</strong></h3>
                            <p>All our learning products are delivered digitally through our online platform. After successful payment, you will receive immediate access to your course(s) or subscription via your registered account.</p>

                            <h3><strong>ACCESS TIMELINE</strong></h3>
                            <ul>
                                <li><strong>Single Course Purchase:</strong> Access is granted instantly upon confirmation of payment.</li>
                                <li><strong>Subscription Plans:</strong> Access is granted for the duration of your active subscription period.</li>
                                <li><strong>Institutional / Enterprise Accounts:</strong> Access is provisioned within 2–3 business days after account setup.</li>
                            </ul>

                            <h3><strong>ARE THERE ANY DELIVERY RESTRICTIONS?</strong></h3>
                            <p>As our courses are digital, no physical delivery applies. However, access may be restricted if:</p>
                            <ul>
                                <li>You fail to complete the payment process.</li>
                                <li>You violate our Terms of Service or usage policies.</li>
                                <li>Technical issues (such as internet outages) occur outside our control.</li>
                            </ul>

                            <h3><strong>INTERNATIONAL ACCESS</strong></h3>
                            <p>Our platform is accessible globally, provided you have a stable internet connection. Some regions may face access restrictions due to local regulations or connectivity limitations.</p>

                            <h3><strong>WHAT HAPPENS IF ACCESS IS DELAYED?</strong></h3>
                            <p>In rare cases where access is delayed due to technical issues, you will be notified via email and our support team will resolve it at the earliest. If the issue persists beyond 48 hours, we will assist you further.</p>

                            <h3><strong>QUESTIONS ABOUT RETURNS?</strong></h3>
                            <p>If you have questions about refunds or cancellations, please review our 
                            <router-link to="/Refund" class="text-decoration-none fw-semibold">Refund & Cancellation Policy</router-link>.</p>

                            <h3><strong>HOW CAN YOU CONTACT US ABOUT THIS POLICY?</strong></h3>
                            <p>If you have any further questions or issues with course delivery, you may contact us by:</p>
                            <ul>
                                <li>Email:lms@dktechs.in</li>
                                <li>Helpdesk: Available via the platform support portal</li>
                            </ul>

                            <p><strong>Last updated April 05, 2025</strong></p>
                        </div>
                    </div>
                                     <router-link to="/" class="btn btn-primary mt-1 mb-1">
                                Go to Home
                                </router-link>
                </div>
            </div>
        </div>
    </div>
</main>
</template>
